let validation = {
  data() {
    return {
      errors: {},
    };
  },
  created() {
    this.clearErrors();
  },
  methods: {
    syncErrors(error) {
      if (error?.response?.data?.errors) {
        this.errors = error.response.data.errors;
      }
    },
    clearErrors() {
      this.errors = {};
    },
    addError(argument) {
      this.errors = {
        ...this.errors,
        ...argument,
      };
    },
    hasErrors(field) {
      return Object.prototype.hasOwnProperty.call(this.errors, field);
    },
    getError(field) {
      if (this.hasErrors(field)) {
        // TODO only shows the first error
        return this.errors[field][0];
      }
      return null;
    },
    getErrors(field) {
      return this.hasErrors(field) ? this.errors[field] : null;
    },
  },
};

export default validation;
